import { render } from "./DepositReviewModal.vue?vue&type=template&id=2c41f51f&scoped=true"
import script from "./DepositReviewModal.vue?vue&type=script&lang=js"
export * from "./DepositReviewModal.vue?vue&type=script&lang=js"

import "./DepositReviewModal.vue?vue&type=style&index=0&id=2c41f51f&lang=css&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c41f51f"]])

export default __exports__